<template>
  <img class="prod-icon" :width="width" :height="height || width" :src="productLogo" :onerror="errorImg">
</template>

<script>
  import defaultImg from '@/assets/images/noproduct.png';
  import { getImgSrc } from '@/utils/utils';
  export default {
    name: "prod-icon",
    props: {
      src: {
        required: true
      },
      width: {
        default: 20,
        type: [Number,String]
      },
      height: {
        type: [Number,String]
      }
    },
    data() {
      return {
        errorImg: `this.src="${defaultImg}"`
      };
    },
    computed: {
      productLogo() {
        if (!this.src) {
          return defaultImg;
        } else {
          return getImgSrc(this.src,this.width);
        }
      }
    }
  };
</script>
<style scoped="scoped">
  .prod-icon {
    object-fit: contain;
    vertical-align: middle;
  }
</style>
